import createIcon from '../../createIcon';

/**
 * @component @name RoomService
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxN0gyMlYxOUgyVjE3Wk0xMy44NCA3Ljc5QzEzLjk0IDcuNTUgMTQgNy4yOCAxNCA3QzE0IDUuOSAxMy4xIDUgMTIgNUMxMC45IDUgMTAgNS45IDEwIDdDMTAgNy4yOCAxMC4wNiA3LjU1IDEwLjE2IDcuNzlDNi4yNSA4LjYgMy4yNyAxMS45MyAzIDE2SDIxQzIwLjczIDExLjkzIDE3Ljc1IDguNiAxMy44NCA3Ljc5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RoomService = createIcon('RoomService', [
  [
    'path',
    {
      d: 'M2 17H22V19H2V17ZM13.84 7.79C13.94 7.55 14 7.28 14 7C14 5.9 13.1 5 12 5C10.9 5 10 5.9 10 7C10 7.28 10.06 7.55 10.16 7.79C6.25 8.6 3.27 11.93 3 16H21C20.73 11.93 17.75 8.6 13.84 7.79Z',
      key: '1xzzyk',
    },
  ],
]);

export default RoomService;
